import { Icon } from '@navinc/base-react-components/wayfinder'
import { useEffect, useState } from 'react'

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.25451 11.4859V18.7862H11.2359V11.4859H14.2047L14.8225 8.12926H11.2359V6.94172C11.2359 5.16727 11.9326 4.48769 13.7311 4.48769C14.2905 4.48769 14.7401 4.50142 15.001 4.52888V1.48452C14.5102 1.35067 13.3089 1.21338 12.6156 1.21338C8.94658 1.21338 7.25451 2.94664 7.25451 6.6843V8.12926H4.98926V11.4859H7.25451Z"
      fill="currentColor"
    />
  </svg>
)
const LinkedinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.16895 18.75H1.54004V7.06641H5.16895V18.75ZM3.35254 5.47266C2.19238 5.47266 1.25098 4.51172 1.25098 3.35156C1.25098 2.79419 1.47239 2.25965 1.86651 1.86553C2.26063 1.47141 2.79517 1.25 3.35254 1.25C3.90991 1.25 4.44445 1.47141 4.83857 1.86553C5.23269 2.25965 5.4541 2.79419 5.4541 3.35156C5.4541 4.51172 4.5127 5.47266 3.35254 5.47266ZM18.7471 18.75H15.126V13.0625C15.126 11.707 15.0986 9.96875 13.2393 9.96875C11.3525 9.96875 11.0635 11.4414 11.0635 12.9648V18.75H7.43848V7.06641H10.9189V8.66016H10.9697C11.4541 7.74219 12.6377 6.77344 14.4033 6.77344C18.0752 6.77344 18.751 9.19141 18.751 12.332V18.75H18.7471Z"
      fill="currentColor"
    />
  </svg>
)
const XIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.2022 1.875H17.96L11.9365 8.75781L19.0225 18.125H13.4756L9.12793 12.4453L4.15918 18.125H1.39746L7.83887 10.7617L1.0459 1.875H6.7334L10.6592 7.06641L15.2022 1.875ZM14.2334 16.4766H15.7607L5.90137 3.4375H4.26074L14.2334 16.4766Z"
      fill="currentColor"
    />
  </svg>
)

const PrintButton = () => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) return null

  return (
    <button className="flex" aria-label="Print" onClick={() => window.print()}>
      <Icon name="print" className="text-[20px]" />
    </button>
  )
}

export const ShareButtons = ({ url, title }: { url: string; title: string }) => {
  const encodedUrl = encodeURIComponent(url)
  const encodedTitle = encodeURIComponent(title)

  const className = 'flex items-center justify-center size-400'
  return (
    <div className="flex justify-center gap-200 text-onSurfaceVariant md:justify-start">
      <a
        className={className}
        target="_blank"
        aria-label="Share on LinkedIn"
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
        rel="noreferrer"
      >
        <LinkedinIcon />
      </a>
      <a
        className={className}
        target="_blank"
        aria-label="Share on X"
        href={`https://x.com/share?url=${encodedUrl}&text=${encodedTitle}`}
        rel="noreferrer"
      >
        <XIcon />
      </a>
      <a
        className={className}
        target="_blank"
        aria-label="Share on Facebook"
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        rel="noreferrer"
      >
        <FacebookIcon />
      </a>
      <a
        className={className}
        target="_blank"
        aria-label="Share via Email"
        href={`mailto:?subject=${encodedTitle}&body=${encodedUrl}`}
        rel="noreferrer"
      >
        <Icon name="mail" className="text-[20px]" />
      </a>
      <div className={className}>
        <PrintButton />
      </div>
    </div>
  )
}
